(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paintmysoul-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paintmysoul-hero-slideshow')) {
    customElements.define(
      'paintmysoul-hero-slideshow',
      class PaintMySoulHeroSlideshow extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;

          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.paginationButtons = Array.from(this.querySelectorAll('[data-slide-to]'));
          this.status = this.querySelector('[data-slide-status]');
          this.track = this.querySelector('[data-slideshow-track]');
          this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          this.autoplayEnabled = this.dataset.autoplay === 'true';
          this.pauseOnHover = this.dataset.pauseOnHover === 'true';
          this.autoplaySpeed = Number.parseInt(this.dataset.autoplaySpeed, 10) || 6000;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.abortController = new AbortController();
          this.pointerId = null;
          this.startX = 0;
          this.startY = 0;
          this.hoverPaused = false;
          this.focusPaused = false;
          this.editorPaused = false;

          const signal = this.abortController.signal;

          this.querySelector('[data-slide-previous]')?.addEventListener('click', () => this.goTo(this.currentIndex - 1, true), { signal });
          this.querySelector('[data-slide-next]')?.addEventListener('click', () => this.goTo(this.currentIndex + 1, true), { signal });

          this.paginationButtons.forEach((button) => {
            button.addEventListener('click', () => this.goTo(Number.parseInt(button.dataset.slideTo, 10), true), { signal });
          });

          this.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.goTo(this.currentIndex - 1, true);
            }
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.goTo(this.currentIndex + 1, true);
            }
          }, { signal });

          if (this.pauseOnHover) {
            this.addEventListener('mouseenter', () => {
              this.hoverPaused = true;
              this.clearTimer();
            }, { signal });
            this.addEventListener('mouseleave', () => {
              this.hoverPaused = false;
              this.schedule();
            }, { signal });
          }

          this.addEventListener('focusin', () => {
            this.focusPaused = true;
            this.clearTimer();
          }, { signal });

          this.addEventListener('focusout', () => {
            window.setTimeout(() => {
              if (!this.contains(document.activeElement)) {
                this.focusPaused = false;
                this.schedule();
              }
            }, 0);
          }, { signal });

          document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
              this.clearTimer();
            } else {
              this.schedule();
            }
          }, { signal });

          this.track?.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
          this.track?.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
          this.track?.addEventListener('pointercancel', () => this.resetPointer(), { signal });

          this.addEventListener('shopify:block:select', (event) => {
            const slide = event.target.closest?.('[data-slide]');
            if (!slide || !this.contains(slide)) return;
            this.editorPaused = true;
            this.goTo(Number.parseInt(slide.dataset.slideIndex, 10), false);
            this.clearTimer();
          }, { signal });

          this.addEventListener('shopify:block:deselect', () => {
            this.editorPaused = false;
            this.schedule();
          }, { signal });

          this.updateSlides(false);
          this.schedule();
        }

        disconnectedCallback() {
          this.clearTimer();
          this.abortController?.abort();
          this.abortController = null;
          this.resetPointer();
        }

        onPointerDown(event) {
          if (this.slides.length < 2 || event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest?.('a, button, input, select, textarea, label, summary')) return;
          this.pointerId = event.pointerId;
          this.startX = event.clientX;
          this.startY = event.clientY;
          this.track?.setPointerCapture?.(event.pointerId);
        }

        onPointerUp(event) {
          if (event.pointerId !== this.pointerId) return;
          const deltaX = event.clientX - this.startX;
          const deltaY = event.clientY - this.startY;
          this.track?.releasePointerCapture?.(event.pointerId);
          this.resetPointer();

          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          this.goTo(this.currentIndex + (deltaX < 0 ? 1 : -1), true);
        }

        resetPointer() {
          this.pointerId = null;
          this.startX = 0;
          this.startY = 0;
        }

        goTo(index, manual) {
          if (this.slides.length < 1 || !Number.isFinite(index)) return;
          this.clearTimer();
          this.currentIndex = (index + this.slides.length) % this.slides.length;
          this.updateSlides(true);
          if (manual) this.editorPaused = false;
          this.schedule();
        }

        updateSlides(announce) {
          this.slides.forEach((slide, index) => {
            const active = index === this.currentIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            slide.inert = !active;
          });

          this.paginationButtons.forEach((button, index) => {
            const active = index === this.currentIndex;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-current', active ? 'true' : 'false');
          });

          if (announce && this.status) {
            this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
          }
        }

        schedule() {
          this.clearTimer();
          if (!this.autoplayEnabled || this.reducedMotion || this.slides.length < 2) return;
          if (this.hoverPaused || this.focusPaused || this.editorPaused || document.hidden) return;
          this.timer = window.setTimeout(() => this.goTo(this.currentIndex + 1, false), this.autoplaySpeed);
        }

        clearTimer() {
          if (!this.timer) return;
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
